import { Component } from '@verndale/core';

class MasonryGallery extends Component {
  setupDefaults() {
    this.dom = {
      gallery: this.el.querySelector<HTMLElement>('.masonry-gallery__gallery'),
      columns: this.el.querySelectorAll<HTMLElement>(
        '.masonry-gallery__column'
      ),
      expandButton: this.el.querySelector<HTMLButtonElement>(
        '.masonry-gallery__cta'
      )
    };

    this.init();
  }

  init() {
    if ((this.dom.columns as NodeList)?.length < 2) {
      (this.dom.expandButton as HTMLButtonElement)?.style.setProperty(
        'display',
        'none'
      );
    }
  }

  addListeners() {
    (this.dom.expandButton as HTMLButtonElement)?.addEventListener(
      'click',
      this.handleClick.bind(this)
    );
  }

  handleClick() {
    const gallery = this.dom.gallery as HTMLElement;
    gallery?.classList.remove('masonry-gallery__gallery--collapsed');
    gallery?.classList.add('masonry-gallery__gallery--expanded');
  }
}

export default MasonryGallery;
